module.exports = __webpack_public_path__ + "img/communityBanner.d7afa5c1.png";